class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    document.dispatchEvent(new CustomEvent("facets:grid-updated"));
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML =
        element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets-mobile", ".active-facets-desktop"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-facets__open", ".mobile-facets__count", ".sorting"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );

    let checkbox = document.querySelector(".sold-out-filter");

    let all_cards = document.querySelectorAll(".product-solds");

    if (checkbox) {
      if (checkbox.checked) {
        console.log("Checkbox is checked testing");

        all_cards.forEach(function (card) {
          card.style.display = "none";
        });
      } else {
        all_cards.forEach(function (card) {
          card.style.display = "block";
        });
      }
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

// Custom solution to filter out sold out cards
function filterCardsByFilters() {
  var FULL_TO_ABBREV = {
    "x-small": ["xs"],
    "extra small": ["xs"],
    small: ["s"],
    medium: ["m"],
    large: ["l"],
    "x-large": ["xl"],
    "extra large": ["xl"],
    "xx-large": ["xxl", "2xl"],
    "double extra large": ["xxl", "2xl"],
    "xxx-large": ["xxxl", "3xl"],
    "one size": ["os", "one size"],
  };

  function sizeMatches(filterText, variantText) {
    if (filterText === variantText) return true;
    var abbrevs = FULL_TO_ABBREV[filterText];
    if (abbrevs) return abbrevs.indexOf(variantText) !== -1;
    return false;
  }

  var activeSizes = [];

  document.querySelectorAll('input[name="filter.v.option.size"]:checked').forEach(function (input) {
    var label = document.querySelector('label[for="' + input.id + '"]');
    if (label) {
      var text = "";
      label.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
      });
      text = text.replace(/\s+/g, " ").trim().toLowerCase();
      if (!text) {
        var span = label.querySelector("span:not(.mobile-facets__highlight)");
        if (span) text = span.textContent.replace(/\s+/g, " ").trim().toLowerCase();
      }
      if (text) activeSizes.push(text);
    }
  });

  var availOut = !!document.querySelector('input[name="filter.v.availability"][value="0"]:checked');
  var availIn = !!document.querySelector('input[name="filter.v.availability"][value="1"]:checked');

  document.querySelectorAll(".card-wrapper").forEach(function (card) {
    var gridItem = card.closest("li.grid__item");
    if (!gridItem) return;

    var buttons = Array.from(card.querySelectorAll(".product-form__buttons .reset-btn"));

    var isSoldOut =
      !!card.querySelector(".price--sold-out") ||
      Array.prototype.some.call(card.querySelectorAll(".badge, .card__badge"), function (b) {
        return /sold\s*out|epuis|rupture/i.test(b.textContent || "");
      }) ||
      (buttons.length > 0 && buttons.every(function (b) { return b.disabled; }));

    var sizeOk = true;
    if (activeSizes.length > 0) {
      if (!buttons.length) {
        sizeOk = false;
      } else {
        sizeOk = buttons.some(function (btn) {
          if (btn.disabled) return false;
          var span = btn.querySelector("span");
          var title = (span ? span.textContent : btn.textContent)
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();
          return activeSizes.some(function (s) {
            return sizeMatches(s, title);
          });
        });
      }
    }

    var availOk = true;
    if (availOut && !availIn) availOk = isSoldOut;
    else if (availIn && !availOut) availOk = !isSoldOut;

    gridItem.style.display = sizeOk && availOk ? "" : "none";
  });
}

document.addEventListener("DOMContentLoaded", filterCardsByFilters);
document.addEventListener("facets:grid-updated", filterCardsByFilters);
window.addEventListener("popstate", filterCardsByFilters);

// End of custom solution to filter out sold out cards

// MNB fix: auto-apply mobile filters on change (Apply button is comfort only)
(function () {
  function submitFacet(input) {
    var form = input.closest("form");
    if (!form) return;
    var ff = form.closest("facet-filters-form");
    if (ff && typeof ff.onSubmitHandler === "function") {
      ff.onSubmitHandler({ preventDefault: function () {}, target: input });
    } else if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }
  function bindMobileAutoApply() {
    var form = document.getElementById("FacetFiltersFormMobile");
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) {
      if (input.dataset.mnbAuto) return;
      input.dataset.mnbAuto = "1";
      input.addEventListener("change", function () {
        submitFacet(input);
      });
    });
  }
  document.addEventListener("DOMContentLoaded", bindMobileAutoApply);
  document.addEventListener("facets:grid-updated", bindMobileAutoApply);
  bindMobileAutoApply();
})();
// End MNB fix
